var viewer_rtlignore_default = {
  "gallery_container": "lJHm7",
  "imageTitleContainer": "fAXAj",
  "clickableItem": "_2u5n-",
  "prerender": "jHOGh",
  "expandButton": "jwxf6",
  "itemContainer": "dS75b",
  "expandIcon": "KI2oY",
  "itemOverlay": "RpV4L",
  "imageTitle": "eHy-U",
  "pointer": "aNQck",
  "fadeIn": "_3kJR-",
  "changing_background": "G2FKg"
};
export {
  viewer_rtlignore_default as default
};
//# sourceMappingURL=viewer.rtlignore-scss.js.map
